import { useEffect, useState } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchFranchiseDropdownDD } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import zoneLocalStorageId from "utils/zone";

const FranchiseDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  formKey,
  defaultValue,
  required,
  all_zone_franchise = 0,
  copyRateMode = false,
  isDisable = false,
  name_code = false,
  zone_wise = false,
  loginUser = false,
}) => {
  const key = formKey || "franchise";
  const selected = watch(key);
  const login = useSelector((state) => state.jwtAuthreducer);
  const [localFranchiseId, setLocalFranchiseId] = useState(null);

  const [isReadOnly, setIsReadOnly] = useState(false);

  useEffect(() => {
    const sub_franchise = localStorage.getItem("sub_franchise");
    const is_franchise_employee = localStorage.getItem("is_franchise_employee");
    const is_super_employee = localStorage.getItem("is_super_employee");

    const isReadOnly =
      Number(sub_franchise) === 1 ||
      Number(is_franchise_employee) === 1 ||
      Number(is_super_employee) === 1;

    setIsReadOnly(isReadOnly);
  }, []);

  const { data, isLoading, refetch, error } = useQuery(
    ["franchise-dropdown", zone_wise ? zoneLocalStorageId() : null],
    () =>
      fetchFranchiseDropdownDD({
        ...login,
        all_zone_franchise,
        ...(zone_wise ? { zone_id: zoneLocalStorageId() } : {}),
      }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    refetch();
  }, [login]);

  useEffect(() => {
    if (copyRateMode) {
      const storedId = localStorage.getItem("franchise_id");
      setLocalFranchiseId(storedId);
    }
  }, [copyRateMode]);

  // useEffect(() => {
  //   if (loginUser && login?.user?.franchise_ids?.length > 0) {
  //     const loginFranchiseId = login.user.franchise_ids[0].franchise_id;
  //     console.log("loginfranchiseid", loginFranchiseId);
  //     if (loginFranchiseId) {
  //       setValue(key, Number(loginFranchiseId), { shouldValidate: false });
  //     }
  //   }
  // }, [loginUser, login, setValue, key]);

  // useEffect(() => {
  //   if (data) {
  //     const options =
  //       data?.data?.data?.map((item) => ({
  //         value: item.id,
  //         label: item.company_name,
  //       })) || [];

  //     let valueToSet = defaultValue;

  //     if (copyRateMode && localFranchiseId) {
  //       valueToSet = Number(localFranchiseId);
  //     }

  //     const defaultOption = options.find(
  //       (option) => option.value === valueToSet
  //     );

  //     if (defaultOption) {
  //       setValue(key, defaultOption.value, { shouldValidate: false });
  //     } else {
  //       setValue(key, "", { shouldValidate: false });
  //     }
  //   }
  // }, [data, defaultValue, localFranchiseId, setValue, key, copyRateMode]);

  useEffect(() => {
    if (!data) return;

    const options =
      data?.data?.data?.map((item) => ({
        value: item.id,
        label: item.company_name,
      })) || [];

    let valueToSet = "";

    if (defaultValue) {
      valueToSet = defaultValue;
    } else if (loginUser && login?.user?.franchise_ids?.length > 0) {
      valueToSet = Number(login.user.franchise_ids[0].franchise_id);
    }
    if (copyRateMode && localFranchiseId) {
      valueToSet = Number(localFranchiseId);
    }

    const matched = options.find((opt) => opt.value === valueToSet);

    if (matched) {
      setValue(key, matched.value, { shouldValidate: false });
    } else {
      setValue(key, "", { shouldValidate: false });
    }
  }, [
    data,
    loginUser,
    login,
    defaultValue,
    copyRateMode,
    localFranchiseId,
    key,
    setValue,
  ]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading franchise type</div>;

  const options =
    data?.data?.data?.map((item) => ({
      value: item.id,
      label: name_code
        ? `${item.franchise_code}/${item.company_name}`
        : item.company_name,
    })) || [];

  const selectedOption =
    options.find((option) => option.value === selected) || null;

  return (
    <>
      {(copyRateMode && isReadOnly) || isDisable ? (
        <input
          type="text"
          value={
            options.find(
              (option) =>
                option.value ===
                Number(copyRateMode ? localFranchiseId : selected)
            )?.label || ""
          }
          readOnly
          disabled
          className={`form-control ${errors[key] ? "is-invalid" : ""}`}
        />
      ) : (
        <Controller
          name={key}
          control={control}
          rules={{
            required: required ? "Franchise is required" : false,
          }}
          render={({ field }) => (
            <div>
              <Select
                options={options}
                isClearable
                placeholder="Select Franchise"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({
                    ...base,
                  }),
                }}
                value={
                  options.find((option) => option.value === field.value) || null
                }
                onChange={(option) => {
                  field.onChange(option ? option.value : "");
                }}
                className={`react-select-container ${
                  errors[key] ? "is-invalid" : ""
                }`}
              />
              {errors[key] && (
                <span
                  style={{
                    color: "#dc3545",
                    fontSize: "0.875em",
                    marginTop: "0.25rem",
                    display: "block",
                  }}
                >
                  {errors[key].message}
                </span>
              )}
            </div>
          )}
        />
      )}
    </>
  );
};

export default FranchiseDropdown;
